function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Card, CardBody, CardHeader, Container, Row, Col, Button } from 'reactstrap';
import { createHashHistory } from 'history';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import checkBrowser from '../../utils/checkBrowser';
import StatusLoader from '../common/statusLoader';
import routeHelper from '../common/classes/routeHelper';
import Icon from '../common/containers/icon';
import PDF from '../common/pdf/pdf';
import PDF_VIEWER_CARD_HEIGHT from '../common/pdf/pdfViewerLayout';
const hashHistory = createHashHistory();
const calculatePercentage = (timeElapsed, totalTime = 600) => {
  if (timeElapsed < 10) {
    return Math.floor(2.5 * timeElapsed);
  }
  return Math.floor(timeElapsed / totalTime * 0.75 * 100) + 24;
};
const FormPDFViewer = props => {
  const {
    form,
    match,
    notificationActions,
    location,
    formActions
  } = props;
  const {
    active,
    error
  } = form;
  const [loadedPercentage, setLoadedPercentage] = useState(0);
  const handleBack = () => {
    routeHelper.updateURL(`${location.pathname.split('/').slice(0, -3).join('/')}`);
  };
  const handleEdit = () => {
    hashHistory.push(`${location.pathname.split('/').slice(0, -1).join('/')}`);
  };
  useEffect(() => {
    formActions.serverRenderForm(match.params.id);
  }, [formActions, match]);
  useEffect(() => {
    const loadedTime = new Date();
    let timeElapsed = (new Date() - loadedTime) / 1000;
    const loadTime = () => {
      timeElapsed = (new Date() - loadedTime) / 1000;
      setLoadedPercentage(calculatePercentage(timeElapsed));
    };
    const timerInterval = setInterval(loadTime, 100);
    if (active && active.signedURL) {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [active]);
  const formTitle = '';
  let url = 'invalidURL';
  const docTitle = '';
  if (match.params.id && active && active.signedURL) {
    url = active.signedURL;
  }
  const buttonStyle = {
    marginRight: '5px',
    float: 'left'
  };
  const isMobileOS = checkBrowser.isMobile();
  const showEdit = true;
  const editButton = /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "t-r-edit",
    title: "Edit form",
    onClick: handleEdit,
    style: buttonStyle
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "pencil-alt"
  }), " Edit");
  const header = /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: showEdit && !isMobileOS ? 3 : 2
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-r-back",
    size: "sm",
    onClick: handleBack,
    style: buttonStyle
  }, "Form Cabinet"), showEdit && !isMobileOS ? editButton : null), /*#__PURE__*/React.createElement(Col, {
    sm: showEdit ? 9 : 10
  }, formTitle)));

  // Fill the card body so Light/Dark overflow rules cannot clip the PDF, without
  // nested card/body scrollbars (browser PDF chrome scrolls pages) — CU-86e2zb5tt.
  const showingPdf = Boolean(active && active.signedURL);
  let content = /*#__PURE__*/React.createElement(StatusLoader, {
    percentage: loadedPercentage,
    loaded: !active
  });
  if (showingPdf) {
    content = /*#__PURE__*/React.createElement(PDF, {
      className: "t-doc-report-detail-pdf",
      title: docTitle,
      src: url,
      hideTitleIfMobile: true,
      nativeRenderer: true,
      containerMaxHeight: "100%"
    });
  } else if (!form.loading) {
    content = /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: '20px'
      }
    }, /*#__PURE__*/React.createElement("h3", null, "There was a problem rendering this form"), /*#__PURE__*/React.createElement("p", null, "Please try again later"));
  }
  if (error) {
    // print the error msg if possible
    if (error.data && error.data.error_msg) {
      notificationActions.error({
        message: error.data.error_msg,
        id: 'form_render_error'
      });
    }
    // print the whole error
    notificationActions.error({
      message: error
    });
  }
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "formPDFViewer"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "t-pdf-viewer-card",
    style: {
      height: PDF_VIEWER_CARD_HEIGHT,
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading-tight"
  }, header), /*#__PURE__*/React.createElement(CardBody, {
    style: _objectSpread({
      flex: 1,
      minHeight: 0,
      overflow: 'hidden'
    }, showingPdf ? {
      padding: 0
    } : {})
  }, content)));
};
FormPDFViewer.propTypes = {
  form: PropTypes.shape({
    active: PropTypes.shape({
      appCreatorID: PropTypes.string,
      signedURL: PropTypes.string,
      content: PropTypes.shape({}),
      formType: PropTypes.shape({
        name: PropTypes.string
      }),
      formNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      statusName: PropTypes.string
    }),
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    pendingChanges: PropTypes.bool
  }).isRequired,
  formActions: PropTypes.shape({
    serverRenderForm: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};
export { FormPDFViewer as TestFormPDFViewer };
export default entityComposition(FormPDFViewer, ['form'], {}, ['notification']);